import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

function FleetSummary(props) {
  const { fromDate, toDate, data } = props;
  const [totalRobots, setTotalRobots] = useState(0);
  const [totalRunTime, setTotalRunTime] = useState("00:00:00");
  const [totalIdleTime, setTotalIdleTime] = useState("00:00:00");
  const [totalIncidents, setTotalIncidents] = useState(0);
  const [totalDistanceTravelled, setTotalDistanceTravelled] = useState("0");
  const [totalDestinations, setTotalDestinations] = useState(0);

  const secToStr = (value) => {
    const seconds = Math.floor(value % 60);
    const minutes = Math.floor((value / 60) % 60);
    const hours = Math.floor(value / 3600);

    return (
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds)
    );
  };

  useEffect(() => {
    if (!data) {
      return;
    }

    let robotSet = new Set();
    if ("incidents" in data) {
      data["incidents"].forEach((incident) => {
        robotSet.add(incident["robot_id"]);
      });
      setTotalIncidents(data["incidents"].length);
    }

    if ("run_times" in data) {
      let runTime = 0;
      let idleTime = 0;
      data["run_times"].forEach((run_time) => {
        robotSet.add(run_time["robot_id"]);
        runTime +=
          run_time["user_auto_duration"] +
          run_time["user_manual_duration"] +
          run_time["operator_auto_duration"] +
          run_time["cleaning_duration"];
        idleTime += run_time["idle_duration"];
      });

      setTotalRunTime(secToStr(runTime));
      setTotalIdleTime(secToStr(idleTime));
    }

    if ("tasks" in data) {
      let totalReached = 0;
      let distanceTravelled = 0;
      data["tasks"].forEach((task) => {
        robotSet.add(task["robot_id"]);
        if (task["status"] === "done") {
          totalReached += task["sub_tasks"].length;
        }
        task["sub_tasks"].forEach((sub_task) => {
          distanceTravelled += sub_task["distance_travelled"];
        });
      });
      setTotalDestinations(totalReached);
      setTotalDistanceTravelled(
        distanceTravelled.toLocaleString(undefined, {
          maximumFractionDigits: 0,
        })
      );
    }

    setTotalRobots(robotSet.size);
  }, [data]);

  return (
    <React.Fragment>
      <Box
        display="flex"
        sx={{
          flexDirection: "column",
          flexGrow: 1,
          backgroundColor: "white",
          marginLeft: "1.5rem",
          marginRight: "1.5rem",
          borderRadius: "2px",
        }}
      >
        <Box
          display="flex"
          sx={{
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "space-between",
            padding: "2rem 1.5rem",
          }}
        >
          <Typography variant="h5" fontWeight="700">
            Fleet Task Report Summary
          </Typography>
          <Typography variant="h5">
            {" " +
              fromDate.toLocaleString("en-US", {
                month: "long",
                day: "numeric",
              })}
            {toDate === null || toDate.getFullYear() !== fromDate.getFullYear()
              ? ", " +
                fromDate.toLocaleString("en-US", {
                  year: "numeric",
                })
              : ""}
            {toDate !== null
              ? " - " +
                toDate.toLocaleString("en-US", {
                  month: "long",
                  day: "numeric",
                }) +
                ", " +
                toDate.toLocaleString("en-US", {
                  year: "numeric",
                })
              : ""}
          </Typography>
        </Box>
        <Box
          display="flex"
          sx={{
            flexGrow: 1,
            alignItems: "stretch",
            justifyContent: "space-evenly",
            alignContent: "stretch",
            gap: "1px",
          }}
        >
          <Box
            display="flex"
            sx={{
              flexDirection: "column",
              flexBasis: "100%",
              backgroundColor: "#35393F",
              justifyContent: "space-evenly",
              alignItems: "flex-start",
              padding: "1rem 1.5rem",
              gap: "0.5rem",
            }}
          >
            <Typography variant="h6" color="white" fontWeight="400">
              Total # of Robots
            </Typography>
            <Typography variant="h6" color="white" fontWeight="700">
              {totalRobots}
            </Typography>
          </Box>
          <Box
            display="flex"
            sx={{
              flexDirection: "column",
              flexBasis: "100%",
              backgroundColor: "#35393F",
              justifyContent: "space-evenly",
              alignItems: "flex-start",
              padding: "1rem 1.5rem",
              gap: "0.5rem",
            }}
          >
            <Typography variant="h6" color="white" fontWeight="400">
              Total Run Time
            </Typography>
            <Typography variant="h6" color="white" fontWeight="700">
              {totalRunTime}
            </Typography>
          </Box>
          <Box
            display="flex"
            sx={{
              flexDirection: "column",
              flexBasis: "100%",
              backgroundColor: "#35393F",
              justifyContent: "space-evenly",
              alignItems: "flex-start",
              padding: "1rem 1.5rem",
              gap: "0.5rem",
            }}
          >
            <Typography variant="h6" color="white" fontWeight="400">
              Total Idle Time
            </Typography>
            <Typography variant="h6" color="white" fontWeight="700">
              {totalIdleTime}
            </Typography>
          </Box>
          <Box
            display="flex"
            sx={{
              flexDirection: "column",
              flexBasis: "100%",
              backgroundColor: "#35393F",
              justifyContent: "space-evenly",
              alignItems: "flex-start",
              padding: "1rem 1.5rem",
              gap: "0.5rem",
            }}
          >
            <Typography variant="h6" color="white" fontWeight="400">
              Total # of Incidents
            </Typography>
            <Typography variant="h6" color="white" fontWeight="700">
              {totalIncidents}
            </Typography>
          </Box>
          <Box
            display="flex"
            sx={{
              flexDirection: "column",
              flexBasis: "100%",
              backgroundColor: "#35393F",
              justifyContent: "space-evenly",
              alignItems: "flex-start",
              padding: "1rem 1.5rem",
              gap: "0.5rem",
            }}
          >
            <Typography variant="h6" color="white" fontWeight="400">
              Total Distance Travelled
            </Typography>
            <Typography variant="h6" color="white" fontWeight="700">
              {totalDistanceTravelled} meters
            </Typography>
          </Box>
          <Box
            display="flex"
            sx={{
              flexDirection: "column",
              flexBasis: "100%",
              backgroundColor: "#35393F",
              justifyContent: "space-evenly",
              alignItems: "flex-start",
              padding: "1rem 1.5rem",
              gap: "0.5rem",
            }}
          >
            <Typography variant="h6" color="white" fontWeight="400">
              Total # of Destinations
            </Typography>
            <Typography variant="h6" color="white" fontWeight="700">
              {totalDestinations}
            </Typography>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default FleetSummary;
